import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { uniqBy, groupBy, forEach, map } from 'lodash'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { List } from 'ui'
import { closeModal } from 'store/actions/modals'
import { t } from 'translations'

const SearchHelpModal = ({ options }) => {
  const dispatch = useDispatch()
  // We only need one object to represent a tag's type, so remove the duplicates,
  // but if helpDisplayValues is true, do not remove the duplicates because we want
  // to display all the values

  const uniqueTags = uniqBy(options, tag => (tag.helpDisplayValues ? tag : tag.label))

  // Group the tags by label
  const groupedTags = groupBy(uniqueTags, tag => tag.label)

  let tagsResult = []

  forEach(groupedTags, tagGroup => {
    // Get the first object so we can access the icon, description, etc, since they all have the same values within a group
    let tag0 = tagGroup[0]

    // Get all the names in a group so that we can display them in the description as the available values
    // If helpDisplayValues is false, no need to go retrieve the values so just set it to null
    let values = tag0.type === 'others' || tag0.displayOptions ? tag0.options.map(tag => ({ text: tag.label, class: tag.class })) : null

    tagsResult.push({
      type: tag0.type,
      label: tag0.label,
      helpName: tag0.helpName || tag0.label,
      helpDescription: tag0.helpDescription,
      values: values,
      icon: tag0.icon
    })
  })

  // If the icon is missing initialize it to 'fa-question'
  const tags = map(tagsResult, tag => (tag.icon ? tag : Object.assign(tag, { icon: 'fa-question' })))

  return (
    <BaseModal hideButtons title="searchBar.HELP_MODAL">
      <List>
        {tags.map(tag => (
          <List.Item key={`${tag.type}-${tag.label}`}>
            <div className="d-flex">
              <span className="mr-2">
                <i className={`fas ${tag.icon}`}></i>
              </span>
              <div>
                <b>{tag.helpName}</b>
                {tag.helpDescription ? <div>{tag.helpDescription}</div> : null}
                {tag.values ? <ViewMore options={tag.values} /> : null}
              </div>
            </div>
          </List.Item>
        ))}
      </List>
      <div className="mt-3">
        <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
          {t(`actions.CLOSE`)}
        </Button>
      </div>
    </BaseModal>
  )
}

const ViewMore = ({ options }) => {
  const [expanded, setExpanded] = useState(false)

  const visibleOptions = options.slice(0, expanded ? undefined : 3)

  return (
    <div>
      <b>{t('searchBar.AVAILABLE_VALUES')}</b>
      {visibleOptions.map((value, index) => (
        <span className={value.class} key={`${value.label}-${index}`}>
          {value.text}
          {index === visibleOptions.length - 1 ? '' : ', '}
        </span>
      ))}
      {options.length > 3 ? (
        <span className="ml-1 cursor-pointer text-link font-italic" onClick={() => setExpanded(!expanded)}>
          {t(`searchBar.${expanded ? 'VIEW_LESS' : 'VIEW_MORE'}`)}
        </span>
      ) : null}
    </div>
  )
}

export default SearchHelpModal
